import React from "react";
import ResourcePersonNavBar from "../ResourcePersonNavBar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

/**
 * ResourcePersonShell — page chrome for the Stage 0–7 authoring screens.
 *
 * Mirrors `components/learner/LearnerShell` (same header layout, same Tailwind
 * idiom) but mounts the **resource-person** navbar, so RP pages never render the
 * learner navigation (`UserNavBar2`).
 *
 * NOTE: `ResourcePersonNavBar` accepts no props — it reads its own
 * title/subtitle from the route and the signed-in RP from the store. The
 * `title`/`subtitle` here are for the page header card only.
 *
 *   <ResourcePersonShell title="Course builder" subtitle="…" icon={faFolderOpen}
 *                        actions={<button/>}>…</ResourcePersonShell>
 */
const ResourcePersonShell = ({title, subtitle, icon, actions, children}) => (
  <div className="min-h-screen bg-slate-50">
    <ResourcePersonNavBar />
    <main className="mx-auto w-full max-w-7xl px-4 pb-24 pt-6">
      <header className="mb-5 flex flex-col gap-3 rounded-xs border border-slate-200 bg-white p-5 shadow-sm sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <h1 className="m-0 flex items-center gap-2 text-xl font-bold text-slate-900 sm:text-2xl">
            {icon ? <FontAwesomeIcon icon={icon} className="text-blue-900" /> : null}
            <span className="truncate">{title}</span>
          </h1>
          {subtitle ? <p className="m-0 mt-1 text-sm text-slate-500">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </header>
      {children}
    </main>
  </div>
);

export default ResourcePersonShell;
